import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { UserService } from 'nr-common';

import { GoogleAnalyticsService } from './services/google-analytics.service';
import { CommonService } from './services/common.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

    constructor(
		public commonService: CommonService,
        translate: TranslateService,
        user: UserService,
        private google: GoogleAnalyticsService
    ) {

        // OM 08.06.2023: Google Analytics
        this.google.init(user);

        translate.addLangs(['it', 'en', 'fr', 'es', 'de', 'nl']);
        translate.setDefaultLang('it');

    }

}
